import { Close } from "@mui/icons-material";
import { Box, IconButton } from "@mui/material";

const ImageContainer = ({ images, onRemove, isMobile }) => {
  if (images.length === 0) return null;

  const isRemovable = typeof onRemove === "function";

  return (
    <Box
      sx={{
        width: isMobile ? "100%" : 430,
        display: "flex",
        flexWrap: "wrap",
        gap: 2,
      }}
    >
      {images.map((image) => (
        <Box
          key={image.id}
          sx={{
            position: "relative",
            width: 100,
            height: 100,
          }}
        >
          <img
            src={image.preview}
            alt="Preview"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: 4,
            }}
          />
          {isRemovable && (
            <IconButton
              size="small"
              onClick={() => onRemove(image.id)}
              sx={{
                position: "absolute",
                top: 3,
                right: 3,
                width: 20,
                height: 20,
                backgroundColor: "white",
                "&:hover": { backgroundColor: "#f5f5f5" },
              }}
            >
              <Close fontSize="small" />
            </IconButton>
          )}
        </Box>
      ))}
    </Box>
  );
};

export default ImageContainer;
